import { Button, ButtonProps } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { FC, ReactNode, forwardRef } from "react";
import { ReactComponent as AddIcon } from "./assets/add.svg";

export const FilterSectionLayout = ({ children }: { children: ReactNode }) => (
  <div className="space-y-3 border-t-0 border-r-0 border-b border-l-0 border-solid border-grey-200 px-12 py-6 transition-colors last:border-b-0 hover:bg-[#FAFAFA]">
    {children}
  </div>
);

FilterSectionLayout.Header = (({ title, endSlot }) => (
  <div className="flex items-center justify-between">
    <span className="text-onyx">{title}</span>
    {endSlot}
  </div>
)) as FC<{ title: string; endSlot?: ReactNode }>;

FilterSectionLayout.AddButton = forwardRef<
  HTMLButtonElement,
  Omit<ButtonProps, "ref">
>((props, ref) => {
  const { t } = useTranslations();

  return (
    <Button
      ref={ref}
      variant="tertiary"
      className="p-2 font-normal"
      iconEnd={<AddIcon />}
      {...props}
    >
      {t({ id: "common.add", defaultMessage: "Add" })}
    </Button>
  );
});

FilterSectionLayout.PillsContainer = (({ children }) => (
  <div className="flex flex-wrap gap-3">{children}</div>
)) as FC<{ children: ReactNode }>;
